import ClientOAuth2 from "client-oauth2";
import axios from "axios";
import { setAuthHeader } from "../utils/axiosHeaders";
import {
  storeUserError,
  storeUser,
  userSignedOut,
} from "../actions/authActions";
import store from "store";

const config = {
  clientId: "react.client",
  accessTokenUri: `../api/v1/identity/access_token`,
  userInfoUri: `../api/v1/profile`,
  endsessionUri: `connect/endsession`,
  introspectURL: `connect/introspect`,
  scopes: [],
};

const oauth = new ClientOAuth2(config);

export async function loadUserFromStorage(store) {
  try {

      let user = await userProfile()

      if (!user) {
        return store.dispatch(storeUserError());
      }
  
      store.dispatch(storeUser(user.data));
      return user.data;

      //return null;


         /*
    user.then((result) => {
      console.log(result);
    })
    .catch((error) => {
      console.error(error);
    });
    

    if (!user) {
      return store.dispatch(storeUserError());
    }

    store.dispatch(storeUser(user.data));

    return user.data;
    */
  } catch (e) {
    console.error(`User not found: ${e}`);
    store.dispatch(storeUserError());
  }
}

export const login = (params) => {
  return oauth.owner
     .getToken(params.email, params.password, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
    .then((result) => {

      if(result.data.success)
      {
        //localStorage.setItem("token", result.data.accessToken);
        //setAuthHeader(result.data.accessToken);
          
        result.data.userDepartment.map(x => 
          {
            delete x['userDepartmentKey']
            delete x['userName']
            delete x['departmentType']
            //delete x['department']
            delete x['userProfile']
            delete x['userLevel']
          }
        )

        localStorage.setItem("currentUser", JSON.stringify(result.data))
        setAuthHeader(result.data.accessToken);

        //get and store user details
        loadUserFromStorage(store);
          return result;
      }
      else
      {

        return result;
      }
      

     
     
    })
    .catch((error) => {
      console.log(error)
      localStorage.removeItem("currentUser");
    });
};

export const loginProvider = (params) => {
    oauth.options.accessTokenUri = '../api/v1/provider/access_token';

    return oauth.owner
        .getToken(params.username, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
        .then((result) => {
            oauth.options.accessTokenUri = "../api/v1/identity/access_token";
            if (result.data.success) {

                result.data.userDepartment.map(x => {
                    delete x['userDepartmentKey']
                    delete x['userName']
                    delete x['departmentType']
                    delete x['department']
                    delete x['userProfile']
                    delete x['userLevel']
                }
                )

                localStorage.setItem("currentUser", JSON.stringify(result.data))
                setAuthHeader(result.data.accessToken);

                //get and store user details
                loadUserFromStorage(store);
                return result;
            }
            else {
                oauth.options.accessTokenUri = "../api/v1/identity/access_token";
                return result;
            }
            
        })
        .catch((error) => {
            oauth.options.accessTokenUri = "../api/v1/identity/access_token";
            console.log(error)
            localStorage.removeItem("currentUser");
        });
};


export const logoff = () => {
  userSignedOut();
};

export const userProfile = () => {

  //var token = localStorage.getItem("token");
  var currentUser = JSON.parse(localStorage.getItem('currentUser'))
  console.log(currentUser)

  if (currentUser.token) {
    axios.defaults.headers.common["Authorization"] = currentUser.token
      ? "Bearer " + currentUser.token
      : "";
      return axios.get(config.userInfoUri);
      /*
      return axios.get(config.userInfoUri).then((result) => {
             //console.log(result);
          })
          .catch((error) => {
            console.error(error);
          });
      */
  } else {
    return null;
  }
};

export const validateToken = (token) => {
  return axios
    .post(config.introspectURL, { token: token })
    .then((result) => {
      console.log(result);
    })
    .catch((error) => {
      console.error(error);
    });
};

export default oauth;
